import { render, staticRenderFns } from "./scoreBon.vue?vue&type=template&id=3e04cff0&"
import script from "./scoreBon.vue?vue&type=script&lang=js&"
export * from "./scoreBon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports